import { render, staticRenderFns } from "./EditHeroUpgradeLeaderboardDialog.vue?vue&type=template&id=3e895cb6&scoped=true"
import script from "./EditHeroUpgradeLeaderboardDialog.vue?vue&type=script&lang=js"
export * from "./EditHeroUpgradeLeaderboardDialog.vue?vue&type=script&lang=js"
import style0 from "./EditHeroUpgradeLeaderboardDialog.vue?vue&type=style&index=0&id=3e895cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e895cb6",
  null
  
)

export default component.exports